import { PlanType } from "../types/planType";

export const injectCustomDescription = async (
  plans: PlanType[],
  stateCode: String | undefined
) => {
  const newPlans = plans.map((plan) => {
    if (
      stateCode === "PA" &&
      plan.plan_name.toLowerCase().trim().includes("flexstart intro")
    ) {
      const planDescription = plan.plan_desc.split(".")[0];
      const disclaimer = plan.plan_desc.split(".").slice(1).join(".").trim();

      // Find all flexstart intro plans with the same name
      const sameNamePlans = plans.filter(p => 
        p.plan_name.toLowerCase().trim().includes("flexstart intro") &&
        p.plan_name.trim() === plan.plan_name.trim()
      );

      let planType = "1-month"; // default for single plan or edge case
      
      if (sameNamePlans.length === 2) {
        // Sort by price to identify 1-month (lower price) vs 3-month (higher price)
        const sortedPlans = sameNamePlans.sort((a, b) => 
          a.price1000 - b.price1000
        );
        
        // Lower price = 1-month plan, higher price = 3-month plan
        planType = plan.price1000 === sortedPlans[0]?.price1000 ? "1-month" : "3-month";
      }

      console.log({sameNamePlans})

      // Update plan bullets if they exist
      let updatedPlanBullets = plan.ef_plan_details?.plan_bullets;
      let updatedPlanBulletsEs = plan.ef_plan_details_ES?.plan_bullets;
      if (updatedPlanBullets) {
        updatedPlanBullets = updatedPlanBullets.map(bullet => {
          if (bullet.text === "No commitment") {
            return {
              ...bullet,
              text: planType === "1-month" 
                ? "Guaranteed introductory price" 
                : "Guaranteed 3-month introductory price"
            };
          }
          return bullet;
        });
      }
      if (updatedPlanBulletsEs) {
        updatedPlanBulletsEs = updatedPlanBulletsEs.map(bullet => {
          if (bullet.text === "Sin compromiso") {
            return {
              ...bullet,
              text: planType === "1-month" 
                ? "Precio de introducción garantizado" 
                : "Precio de introducción garantizado por 3"
            };
          }
          return bullet;
        });
      }

      return {
        ...plan,
        ef_plan_details: {
          ...plan.ef_plan_details,
          plan_bullets: updatedPlanBullets,
          plan_descriptions: {
            ...plan.ef_plan_details?.plan_descriptions,
            "Plan Description": planDescription,
            Disclaimer: disclaimer,
          },
        },
        ef_plan_details_ES: {
          ...plan.ef_plan_details_ES,
          plan_bullets: updatedPlanBulletsEs,
          plan_descriptions: {
            ...plan.ef_plan_details_ES?.plan_descriptions,
            "Plan Description": planDescription,
            Disclaimer: disclaimer,
          },
        }
      };
    } else {
      return plan;
    }
  });
  return newPlans;
};